import angular from 'angular';
import analyticsVisualizations from '../Components/analyticsVisualizations/analyticsVisualizations.component';

export default angular
    .module('app.analytics.analyticsVisualizations', [])
    .component("analyticsVisualizations", analyticsVisualizations)
    .name;